import {Injectable} from '@angular/core';
import {AlertModalService} from '../component/modal';
import {AppConfigService} from './app-config.service';
import { HttpClient } from '@angular/common/http';
import {interval, Subscription, tap, timer} from 'rxjs';
import {AuthenticatorService} from './authenticator.service';

@Injectable({
    providedIn: 'root'
})
export class SessionManagerService {
    title = 'Session Management Service';
    private tokenDurationMilliseconds = 0;
    private refreshTokenSubscription: Subscription;
    private sessionTimeoutSubscription: Subscription;

    constructor(
        private alertModalService: AlertModalService,
        private appConfigService: AppConfigService,
        private authenticationService: AuthenticatorService,
        private http: HttpClient
    ) {}

    init() {
        console.info(`${this.title} - init`);
        return this.http.get(`${this.appConfigService.settings.apiGatewayUrl}/auth/tokenDuration`).pipe(
            tap({
                next: data => {
                    this.tokenDurationMilliseconds = (data as number) * 1000;
                    this.applySessionManagement();
                    this.startRefreshTokenTimer();
                }
            })
        );
    }

    clear() {
        console.log('clear session management subscription');
        if (this.refreshTokenSubscription) {
            this.refreshTokenSubscription.unsubscribe();
        }
    }

    private expireSessionAlert() {
        console.debug(`${this.title} - expireSession`);
        if (window.onbeforeunload) {
            window.onbeforeunload = null;
        }
        this.alertModalService.createAlertMessage('Your session has expired.', 'Ok', 'Session Expired').subscribe(() => {
            this.authenticationService.logout();
            this.authenticationService.redirectToPF();
        });
    }

    private refreshToken() {
        console.debug(`${this.title} - refreshToken`);
        this.http.get(`${this.appConfigService.settings.apiGatewayUrl}/auth/refreshToken`).subscribe({
            next: res => {
                const token = res;
                if (token) {
                    if (localStorage['jwtToken']) {
                        localStorage.removeItem('jwtToken');
                    }
                    localStorage['jwtToken'] = token;
                } else {
                    console.debug(`${this.title} - Token not found`);
                    this.expireSessionAlert();
                }
            },
            error: error => {
                console.error(`${this.title} - Not logged in... Redirecting to AUTH`);
                this.expireSessionAlert();
            }
        });
    }

    private startRefreshTokenTimer() {
        if (this.refreshTokenSubscription) {
            this.refreshTokenSubscription.unsubscribe();
        }
        const refreshInterval = Math.round(this.tokenDurationMilliseconds / 2);
        this.refreshTokenSubscription = interval(refreshInterval).subscribe(() => this.refreshToken());
    }

    private applySessionManagement() {
        console.debug(`${this.title} - applySessionManagement`);

        this.sessionTimeoutSubscription?.unsubscribe();

        this.sessionTimeoutSubscription = timer(this.tokenDurationMilliseconds).subscribe(() => {
            this.expireSessionAlert();
        });
    }
}
